import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "study-assistant-modal__body" }
const _hoisted_2 = {
  key: 0,
  class: "study-assistant-modal__message study-assistant-modal__error"
}
const _hoisted_3 = {
  key: 1,
  class: "study-assistant-modal__message study-assistant-modal__warning"
}
const _hoisted_4 = {
  key: 2,
  class: "study-assistant-modal__loading"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 4,
  class: "study-assistant-modal__body__text"
}
const _hoisted_8 = {
  key: 5,
  class: "study-assistant-modal__body__pagination"
}
const _hoisted_9 = ["tabindex"]
const _hoisted_10 = ["tabindex"]
const _hoisted_11 = ["aria-label", "disabled", "onClick"]
const _hoisted_12 = ["src", "alt"]

import { ModalInfo, FooterActions } from '@/types/study-assistant-interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'StudyAssistantModal',
  props: {
    showModal: { type: Boolean },
    modalInfo: {},
    modalIndex: {},
    MagicWandPinkIcon: {},
    footerActions: {}
  },
  emits: [
    'closeStudyAssistantModal',
    'changeStudyAssistantModalIndex',
    'regenerateAIOutput'
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "study-assistant-modal",
    modal: "",
    visible: props.showModal,
    header: props.modalInfo.header,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (emit('closeStudyAssistantModal')))
  }, {
    footer: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.footerActions, (action) => {
        return (_openBlock(), _createElementBlock("button", {
          key: action.name,
          class: _normalizeClass(["study-assistant-modal__icon", props.modalInfo.body[props.modalIndex] === 'Loading' ? 'disabled' : '']),
          "aria-label": action.name,
          disabled: props.modalInfo.body[props.modalIndex] === 'Loading',
          onClick: () => {
                    !props.modalInfo.isLoading && action.onclick(props.modalInfo.editor, props.modalInfo.body[_ctx.modalIndex])
                }
        }, [
          _createElementVNode("img", {
            src: action.image,
            alt: `${action.name} Icon`,
            "aria-hidden": "true"
          }, null, 8, _hoisted_12)
        ], 10, _hoisted_11))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.modalInfo.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[4] || (_cache[4] = _createElementVNode("i", {
                class: "pi pi-exclamation-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(props.modalInfo.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (props.modalInfo.warningMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("i", {
                class: "pi pi-exclamation-triangle",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(props.modalInfo.warningMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (props.modalInfo.isLoading && props.modalInfo.body[_ctx.modalIndex] === 'Loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.MagicWandPinkIcon,
                alt: "Study Assistant Loading Icon",
                "aria-hidden": "true"
              }, null, 8, _hoisted_5),
              _cache[6] || (_cache[6] = _createTextVNode(" AI is working on it... "))
            ]))
          : (props.modalInfo.header === 'Define')
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                innerHTML: props.modalInfo.body[props.modalIndex]
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(props.modalInfo.body[props.modalIndex]), 1)),
        (props.modalInfo.body.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("i", {
                class: _normalizeClass(["pi pi-chevron-left", props.modalIndex === 0 ? 'disabled' : '']),
                "aria-label": "Previous result",
                tabindex: props.modalIndex === 0 ? -1 : 0,
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('changeStudyAssistantModalIndex', -1)))
              }, null, 10, _hoisted_9),
              _createElementVNode("div", null, _toDisplayString(props.modalIndex + 1) + " / " + _toDisplayString(props.modalInfo.body.length), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["pi pi-chevron-right", props.modalIndex === props.modalInfo.body.length - 1 ? 'disabled' : '']),
                "aria-label": "Next result",
                tabindex: props.modalIndex === props.modalInfo.body.length - 1 ? -1 : 0,
                role: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('changeStudyAssistantModalIndex', 1)))
              }, null, 10, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        (props.modalInfo.body[props.modalIndex] !== 'Loading')
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              "aria-label": "Regenerate AI response",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('regenerateAIOutput', props.modalInfo.editor)))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", {
                class: "pi pi-replay",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("div", null, "Regenerate", -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})